<script>
    import {mapState} from "vuex";

    export default {
        data: function () {
            return {
                componentId: this._uid
            };
        },

        methods: {
            startLoadingAnimation: function () {
                this.$store.commit("loadingElement/push", this.componentId)
            },

            stopLoadingAnimation: function () {
                this.$store.commit("loadingElement/delete", this.componentId)
            }
        },

        computed: {
            ...mapState({
                loadingElements: state => state.loadingElement.elementIds
            }),

            isLoading: function () {
                return this.loadingElements.indexOf(this.componentId) !== -1;
            }
        }
    }
</script>
